import Link from '@commons/components/Link';

import type { PageNodeProps } from '.';

/**
 * Page node component for the Label display type.
 */

const PageNodeLabel = ({ title, alias }: PageNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default PageNodeLabel;
